import oData from '../server/odata_client';
import oData_equipment from '../server/odata_equipment_client';
import ServerEquipment from '../server/serverEquipment';
import * as ofbiz from '../server/ofbiz';
import { adaptMonitorTreeToLegacy } from '../server/ofbiz/adapters';
import Store from '../script/store';
import Util from '../script/utils.js';
import moment from 'moment';

import * as requestDataActions from './requestData_action';
import * as homeActions from './home_action';
import * as threeDPerspectiveDiagramActions from './threeDPerspectiveDiagram_action';
// import { setMonitorView } from './deviceMonitor_action';

export const SET_DEVICEMONITORTREEDATA = 'SET_DEVICEMONITORTREEDATA';
export const SET_AREADATA = 'SET_AREADATA';
export const SET_DEVICERESOURCEDEPENDTREEDATA = 'SET_DEVICERESOURCEDEPENDTREEDATA';
export const SET_DEVICE_MONITOR_TREE_MAP = 'SET_DEVICE_MONITOR_TREE_MAP';
export const SET_TREE_STORE = 'SET_TREE_STORE';
export const SET_RESOURCE_PANEL_SHOW = 'SET_RESOURCE_PANEL_SHOW';
export const SET_RESOURCE_PANEL_TYPE = 'SET_RESOURCE_PANEL_TYPE';
export const SET_RESOURCE_PANEL_DRAWER_SHOW = 'SET_RESOURCE_PANEL_DRAWER_SHOW';
export const SET_ALLEQUIPMENTANDMONITORDATA = 'SET_ALLEQUIPMENTANDMONITORDATA';
export const SET_STATESTATISTICSDATA = 'SET_STATESTATISTICSDATA';
export const SET_TREEMAPDATA = 'SET_TREEMAPDATA';
export const SET_HISTORYSTATUSMAP = 'SET_HISTORYSTATUSMAP';
export const SET_ALLSTATESTATISTICSPECENTDATA = 'SET_ALLSTATESTATISTICSPECENTDATA';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';

export function setTreeMapData(treeMapData) {
  return {
    type: SET_TREEMAPDATA,
    treeMapData
  }
}

export function setHistoryStatusMap(historyStatusMap) {
  return {
    type: SET_HISTORYSTATUSMAP,
    historyStatusMap
  }
}

export function setAllEquipmentAndMonitorData(allEquipmentAndMonitorData) {
  return {
    type: SET_ALLEQUIPMENTANDMONITORDATA,
    allEquipmentAndMonitorData
  }
}

export function setAllStateStatisticsPecentData(allStateStatisticsPecentData) {
  return {
    type: SET_ALLSTATESTATISTICSPECENTDATA,
    allStateStatisticsPecentData
  }
}

export function setStateStatisticsData(stateStatisticsData) {
  return {
    type: SET_STATESTATISTICSDATA,
    stateStatisticsData
  }
}

export function setDeviceMonitorTreeData(deviceMonitorTreeData) {
    return {
        type: SET_DEVICEMONITORTREEDATA,
        deviceMonitorTreeData
    }
}

export function setAreaData(areaData) {
    return {
        type: SET_AREADATA,
        areaData
    }
}

export function setDeviceResourceDependTreeData(deviceResourceDependTreeData) {
    return {
        type: SET_DEVICERESOURCEDEPENDTREEDATA,
        deviceResourceDependTreeData
    }
}

export function setDeviceMonitorTreeMap(deviceMonitorTreeMap) {
    return {
        type: SET_DEVICE_MONITOR_TREE_MAP,
        deviceMonitorTreeMap
    }
}

export function setTreeStore(treeStore) {
    return {
        type: SET_TREE_STORE,
        treeStore
    }
}

export function setResourcePanelShow(resourcePanelShow){
  return {
    type: SET_RESOURCE_PANEL_SHOW,
    resourcePanelShow
  }
}

export function setResourcePanelType(resourcePanelType){
  return {
    type: SET_RESOURCE_PANEL_TYPE,
    resourcePanelType
  }
}

export function setResourcePanelDrawerShow(resourcePanelDrawerShow){
  return {
    type: SET_RESOURCE_PANEL_DRAWER_SHOW,
    resourcePanelDrawerShow
  }
}

export function openResourcePanel(type){
  return (dispatch, getState) => {
    var { resourcePanelShow, resourcePanelDrawerShow } = getState().deviceMonitorTreeReducer;
    if (!resourcePanelShow && type) {
      dispatch(setResourcePanelShow(true));
    }
    if (!type && resourcePanelShow) {
      dispatch(setResourcePanelShow(false));
      if (resourcePanelDrawerShow) {
        dispatch(setResourcePanelDrawerShow(false));
      }
    }
    dispatch(setResourcePanelType(type || ''));
  }
}


function receiveGetDeviceMonitorTree(data,callback) {
    return dispatch => {
        // if(data.results.length == 0){
        //     // _this.emit("change");
        //     dispatch(requestDataActions.setRequestFail());
        //     return;
        // }
        // var tempdata = data.results[0];
        // // //通过eval() 函数可以将JSON字符串转化为对象
        // var dataobj = eval(tempdata);
        // dataobj = dataobj.MONITORTREE;
        // dataobj = eval('('+dataobj+')'); //将json对像转成数组
        var areaData = [];
        // for(var i = 0; i < dataobj.length; i++) {
        //     if(dataobj[i].type=="organize" || dataobj[i].type=="other") {
        //         // _this.areaData.push(dataobj[i]);
        //         areaData.push(dataobj[i]);
        //     }
        // }
        // let arr = [];
        // dataobj.map(item=>{
        //   if (!arr.find(item2=>{return item2.id === item.id})) {
        //     arr.push(item);
        //   }
        // });
        dispatch(setDeviceMonitorTreeData(data));
        dispatch(setAreaData(areaData));
        // _this.deviceMonitorTreeData = dataobj;
        // _this.emit("change");
        setTimeout(()=>{
          callback && callback(1);
        },100);
        dispatch(requestDataActions.setRequestSuccess());
    }
}

window.treeLoadFlag = 0;
function oDataGetDeviceMonitorTree(filter,callback) {
    return dispatch => {
      // === 已切换到 OFBiz 新接口 /monitor/tree ===
      // 新接口返回 { tree:[...], statusStatistics:{...} }，节点用 children/monitors
      // + camelCase 字段。旧下游代码（receiveGetDeviceMonitorTree 及各组件）期望的是
      // EccGroup 数组结构（GroupEquipment/EquipmentMonitor + RecId/Title/NodeType 等
      // PascalCase 字段），这里做结构转换适配。
      ofbiz.getMonitorTree({}).then(res => {
        console.log('[getDeviceMonitorTreeData] monitor/tree 返回:', res);
        const result = res || {};
        const tree = result.tree || result || [];
        // 转换成旧 EccGroup 结构
        const data = adaptMonitorTreeToLegacy(Array.isArray(tree) ? tree : [tree]);
        console.log('[getDeviceMonitorTreeData] 转换后:', data);
        finishTreeLoad(dispatch, data, callback);
      }).catch(err => {
        // 打印真实错误便于定位（可能是网络错误，也可能是下游同步异常冒泡）
        console.error('[getDeviceMonitorTreeData] 获取资源树失败:', err);
        callback && callback(0);
        if (window.treeLoadFlag == 0) {
          Util.showMessageDialog('系统提示', '获取资源树数据失败。', 'error');
          window.treeLoadFlag ++;
        }
      });
    }
}

/**
 * 完成树加载的后置流程。
 *
 * ⚠️ 原 NetWorkNode/Relation 走旧 OData 接口（/bods.svc/NetWorkNode 等），
 * 用于给资源树的设备标注拓扑 NodeType。新后端 /topo/getNodes 需要 mapId
 * （语义不匹配：资源树这里没有具体拓扑图 ID），且走旧鉴权会阻断页面。
 * 故暂跳过拓扑合并，直接完成树渲染。NodeType 改由设备自身字段决定。
 * 等拓扑页迁移时（有 mapId 上下文）再走 /topo/getNodes、/topo/getEdges。
 */
function finishTreeLoad(dispatch, data, callback) {
  // 清空拓扑相关 redux 状态（原 setNetworkNodes/setRelations 的兜底）
  dispatch(threeDPerspectiveDiagramActions.setNetworkNodes([]));
  dispatch(threeDPerspectiveDiagramActions.setRelations([]));
  dispatch(receiveGetDeviceMonitorTree(data, callback));
}

// adaptMonitorTreeToLegacy / adaptEquipToLegacy / adaptMonitorToLegacy 已提取到
// src/app/server/ofbiz/adapters.js，供多个 action 共享复用。

export function getDeviceMonitorTreeData(filter,callback) {
    return dispatch => {
        // dispatch(setDeviceMonitorTreeData([]));
        // dispatch(setAreaData([]));
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetDeviceMonitorTree(filter,callback))
    }
}

function receiveGetDeviceMonitorTreeByType(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        var tempdata = data.results[0];
        // //通过eval() 函数可以将JSON字符串转化为对象
        var dataobj = eval(tempdata);
        dataobj = dataobj.MONITORTREE;
        dataobj = eval('('+dataobj+')');//将json对像转成数组
        var areaData = [];
        for(var i = 0; i < dataobj.length; i++) {
            if(dataobj[i].type=="organize" || dataobj[i].type=="other") {
                // _this.areaData.push(dataobj[i]);
                areaData.push(dataobj[i]);
            }
        }
        dispatch(setDeviceMonitorTreeData(dataobj));
        dispatch(setAreaData(areaData));
        // _this.deviceMonitorTreeData = dataobj;
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}
function oDataGetDeviceMonitorTreeByType(filter) {
    return dispatch => {
		oData.getDeviceMonitorTreeByType(filter,
      data => dispatch(receiveGetDeviceMonitorTreeByType(data)),(res)=>{
        // Util.parseResponseErrorInfo(res,(errInfo)=>{
        //   dispatch(homeActions.setHintDialogInfo(errInfo));
        // });
      });
    }
}
export function getDeviceMonitorTreeDataByType(filter) {
    return dispatch => {
        // dispatch(setDeviceMonitorTreeData([]));
        // dispatch(setAreaData([]));
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetDeviceMonitorTreeByType(filter))
    }
}

export function getDeviceResourceDependTreeData(filt) {
    return dispatch => {
      var filter = [{key:"ISMONITOR", value:filt.isMonitor}];
        dispatch(requestDataActions.setRequest());
        oData.getDeviceResourceDependTreeData(filter, function(data){
          if(data.results.length == 0){
              // _this.emit("change");
              dispatch(requestDataActions.setRequestFail());
              return;
          };
          var tempdata = data.results[0];
          // //通过eval() 函数可以将JSON字符串转化为对象
          var dataobj = eval(tempdata);
          dataobj = dataobj.MONITORTREE;
          dataobj = eval('('+dataobj+')');//将json对像转成数组
          // var areaData = [];
          // for(var i = 0; i < dataobj.length; i++) {
          //     if(dataobj[i].type=="organize" || dataobj[i].type=="other") {
          //         // _this.areaData.push(dataobj[i]);
          //         areaData.push(dataobj[i]);
          //     }
          // }
          dispatch(setDeviceResourceDependTreeData(dataobj));
          // dispatch(setAreaData(areaData));
          // _this.deviceMonitorTreeData = dataobj;
          // _this.emit("change");
          dispatch(requestDataActions.setRequestSuccess());
        },(res)=>{
          // Util.parseResponseErrorInfo(res,(errInfo)=>{
          //   dispatch(homeActions.setHintDialogInfo(errInfo));
          // });
        });
    }
}

//获取状态巴图 数据
export function getStateStatisticsData(filter, callback, noSetState) {
  return dispatch => {
    ServerEquipment.getAllEquipmentAndMonitor(filter, (data) => {
      let allPecent = {};
      if (data && data.all) {
        let range = filter.endTime - filter.startTime;
        data.all.forEach((r) => {
          r.MonitorStauts.forEach((m) => {
            let stateData = [];
            for(let msrIndex = 0; msrIndex < m.state.recored.length; msrIndex++) {
              let msr = m.state.recored[msrIndex];
              let stateObj = {}, startTime = moment(msr.begin).valueOf(), endTime = moment(msr.end).valueOf();
              if (endTime < filter.startTime || startTime > filter.endTime) {
                continue;   //不在查询时间段内   直接循环下一个
              }
              if(startTime < filter.startTime && endTime > filter.startTime) {
                startTime = filter.startTime;
              }
              if(startTime < filter.endTime && endTime > filter.endTime) {
                endTime = filter.endTime;
              }
              if (stateData.length === 0) {
                if(startTime > filter.startTime && endTime > filter.startTime) {
                  //空数据时间段
                  stateData.push({
                    startTime: moment(filter.startTime).format(dateFormat),
                    endTime: moment(startTime).format(dateFormat),
                    pecent: ((parseInt((startTime - filter.startTime)*100))/range).toFixed(2),
                    values: [],
                    type: 'empty'
                  });
                }
                stateObj.startTime = moment(startTime).format(dateFormat);
                stateObj.endTime = moment(endTime).format(dateFormat);
                stateObj.pecent = ((parseInt((endTime - startTime)*100))/range).toFixed(2);
                stateObj.values = Util.handerArray(msr.current_value);
                stateObj.type = msr.type;
                stateData.push(stateObj);
                if (allPecent.hasOwnProperty(msr.type)) {
                  allPecent[msr.type] += endTime - startTime;
                } else {
                  allPecent[msr.type] = endTime - startTime;
                }
                if (msrIndex === m.state.recored.length - 1 && endTime < filter.endTime) {
                  //未到查询结束时间的   补上空颜色条
                  var preTotal = 0;
                  stateData.forEach((sd) => {
                    preTotal += Number(sd.pecent);
                  });
                  stateData.push({
                    startTime: moment(stateData[stateData.length - 1].endTime).format(dateFormat),
                    endTime: moment(filter.endTime).format(dateFormat),
                    pecent: (100 - preTotal).toFixed(2),
                    values: [],
                    type: 'empty'
                  });
                }
              } else {
                if (startTime != moment(stateData[stateData.length - 1].endTime).valueOf()) {
                  //空数据时间段
                  stateData.push({
                    startTime: moment(stateData[stateData.length - 1].endTime).format(dateFormat),
                    endTime: moment(msr.begin).format(dateFormat),
                    pecent: ((parseInt((moment(msr.begin).valueOf() - moment(stateData[stateData.length - 1].endTime).valueOf())*100))/range).toFixed(2),
                    values: [],
                    type: 'empty'
                  });
                }
                stateObj.startTime = moment(startTime).format(dateFormat);
                stateObj.endTime = moment(endTime).format(dateFormat);
                stateObj.pecent = ((parseInt((endTime - startTime)*100))/range).toFixed(2);
                stateObj.values = Util.handerArray(msr.current_value);
                stateObj.type = msr.type;
                stateData.push(stateObj);
                if (allPecent.hasOwnProperty(msr.type)) {
                  allPecent[msr.type] += endTime - startTime;
                } else {
                  allPecent[msr.type] = endTime - startTime;
                }
                if (msrIndex === m.state.recored.length - 1 && endTime < filter.endTime) {
                  //未到查询结束时间的   补上空颜色条
                  var preTotal = 0;
                  stateData.forEach((sd) => {
                    preTotal += Number(sd.pecent);
                  });
                  stateData.push({
                    startTime: moment(stateData[stateData.length - 1].endTime).format(dateFormat),
                    endTime: moment(filter.endTime).format(dateFormat),
                    pecent: (100 - preTotal).toFixed(2),
                    values: [],
                    type: 'empty'
                  });
                }
              }
            }
            if (stateData.length === 0) {
              //数据为空时  填充空颜色条
              stateData.push({
                startTime: moment(filter.startTime).format(dateFormat),
                endTime: moment(filter.endTime).format(dateFormat),
                pecent: 100.00,
                values: [],
                type: 'empty'
              });
            } else {
              if (allPecent.hasOwnProperty('total')) {
                allPecent.total += range;
              } else {
                allPecent.total = range;
              }
            }
            m.state.stateData = stateData;
          });
        });
        // console.log(data.all);
        if (!noSetState) {
          if (allPecent.hasOwnProperty('total')) {
            if (allPecent.hasOwnProperty('good')) {
              let pecent = (parseInt(allPecent.good*100))/allPecent.total;
              if (pecent > 100) {
                pecent == 100;
              } else if(pecent < 0){
                pecent == 0;
              }
              allPecent.good = pecent.toFixed(2);
            } else {
              allPecent.good = 0;
            }
            if (allPecent.hasOwnProperty('error')) {
              let pecent = (parseInt(allPecent.error*100))/allPecent.total;
              if (pecent > 100) {
                pecent == 100;
              } else if(pecent < 0){
                pecent == 0;
              }
              allPecent.error = pecent.toFixed(2);
            } else {
              allPecent.error = 0;
            }
            if (allPecent.hasOwnProperty('warning')) {
              let pecent = (parseInt(allPecent.warning*100))/allPecent.total;
              if (pecent > 100) {
                pecent == 100;
              } else if(pecent < 0){
                pecent == 0;
              }
              allPecent.warning = pecent.toFixed(2);
            } else {
              allPecent.warning = 0;
            }
            if (allPecent.hasOwnProperty('disabled')) {
              let pecent = (parseInt(allPecent.disabled*100))/allPecent.total;
              if (pecent > 100) {
                pecent == 100;
              } else if(pecent < 0){
                pecent == 0;
              }
              allPecent.disabled = pecent.toFixed(2);
            } else {
              allPecent.disabled = 0;
            }
            let npecent = 100 - Number(allPecent.good) - Number(allPecent.error) - Number(allPecent.warning) - Number(allPecent.disabled);
            if (npecent > 100) {
              npecent == 100;
            } else if(npecent < 0){
              npecent == 0;
            }
            allPecent.nodata = npecent.toFixed(2);
          }
          dispatch(setAllStateStatisticsPecentData(allPecent));
          dispatch(setStateStatisticsData(data.all));
        }
        callback && callback(true, data.all);
      } else {
        if (!noSetState) {
          dispatch(setAllStateStatisticsPecentData(allPecent));
          dispatch(setStateStatisticsData([]));
        }
        callback && callback(false, []);
      }
    }, (status) => {
      callback && callback(false);
    });
  }
}

//获取所有资源及其监测器 （根据时间范围）
export function getAllEquipmentAndMonitor(filter, callback){
  return dispatch => {
    ServerEquipment.getAllEquipmentAndMonitor(filter, (data) => {
      if (data && data.all) {
        dispatch(setAllEquipmentAndMonitorData(data.all));
        callback && callback(true);
      } else {
        dispatch(setAllEquipmentAndMonitorData([]));
        callback && callback(false);
      }
    }, (status) => {
      callback && callback(false);
    });
    // oData.getAllEquipmentAndMonitor(null, (data)=>{
    //   let mTotal = 0, mCount = 0;
    //   data.forEach((item, index) => {
    //     item.mtotal = item.EquipmentMonitor.length;
    //     mTotal+=item.EquipmentMonitor.length;
    //     item.mgood = 0;
    //     item.mwarning = 0;
    //     item.merror = 0;
    //     item.mdisabled = 0;
    //     item.EquipmentMonitor.forEach((monitor, mIndex) => {
    //       if (monitor.IsDisable) {
    //         item.mdisabled++;
    //       } else {
    //         item['m'+monitor.MonitorStatus]++;
    //       }
    //       let params = {
    //         MonitorId: monitor.RecId,
    //         startTime: filter.startTime,
    //         endTime: filter.endTime
    //       };
    //       ServerEquipment.getStatusReportData(params, (reportData) => {
    //         mCount++;
    //         monitor.statusReportData = reportData;
    //         if (mCount == mTotal) {
    //           dispatch(setAllEquipmentAndMonitorData(data));
    //           callback && callback(true);
    //         }
    //       }, (reportStatus) => {
    //         mCount++;
    //         monitor.statusReportData = null;
    //         if (mCount == mTotal) {
    //           dispatch(setAllEquipmentAndMonitorData(data));
    //           callback && callback(true);
    //         }
    //       });
    //     });
    //     if (item.mtotal) {
    //       item.mgoodpecent = (parseInt(item.mgood*100)/item.mtotal).toFixed(2);
    //       item.mwarningpecent = (parseInt(item.mwarning*100)/item.mtotal).toFixed(2);
    //       item.merrorpecent = (parseInt(item.merror*100)/item.mtotal).toFixed(2);
    //       item.mdisabledpecent = (parseInt(item.mdisabled*100)/item.mtotal).toFixed(2);
    //     } else {
    //       item.mgoodpecent = 0;
    //       item.mwarningpecent = 0;
    //       item.merrorpecent = 0;
    //       item.mdisabledpecent = 0;
    //     }
    //   });
    // }, (status) => {
    //   if (status.errmsg == 'token invalid.') {
    //     Util.showMessageDialog('提示', '认证失效，请重新登录。', 'error');
    //     location.href = '#/login';
    //   } else {
    //     Util.showMessageDialog('提示', '获取资源和监测器数据失败。', 'error');
    //   }
    //   callback && callback(false);
    // });
  }
}

//获取矩阵树图数据
// 已切换到 OFBiz 新接口 /monitor/tree（同 getDeviceMonitorTreeData）
export function getTreeMapData(filter, callback) {
  return dispatch => {
    ofbiz.getMonitorTree({}).then(res => {
      const result = res || {};
      const tree = result.tree || result || [];
      // 转换成旧 EccGroup 结构（Util.formatTreeMapData 期望旧格式）
      const datas = adaptMonitorTreeToLegacy(Array.isArray(tree) ? tree : [tree]);
      let { treeData } = Util.formatTreeMapData(datas);
      dispatch(setTreeMapData(treeData));
      dispatch(getStateStatisticsData(filter, (flag, data) => {
        if (flag) {
          let historyStatusMap = {};
          data.forEach((item)=>{
            historyStatusMap[item.EqId] = item;
            if (item.MonitorStauts) {
              item.MonitorStauts.forEach((item2)=>{
                historyStatusMap[item2.mid] = item2;
              });
            }
          });
          dispatch(setHistoryStatusMap(historyStatusMap));
          callback && callback(true);
        } else {
          callback && callback(false);
        }
      }, true));
    }).catch(err => {
      console.error('[getTreeMapData] 获取矩阵树图失败:', err);
      callback && callback(false);
      dispatch(setTreeMapData([]));
    });
  }
}
